import { render, staticRenderFns } from "./orderListComp.vue?vue&type=template&id=5a76b8a4&scoped=true"
import script from "./orderListComp.vue?vue&type=script&lang=js"
export * from "./orderListComp.vue?vue&type=script&lang=js"
import style0 from "./orderListComp.vue?vue&type=style&index=0&id=5a76b8a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a76b8a4",
  null
  
)

export default component.exports